import { render, staticRenderFns } from "./FieldPermissionList.vue?vue&type=template&id=08a4bad0"
import script from "./FieldPermissionList.vue?vue&type=script&lang=js"
export * from "./FieldPermissionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports